import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import {
  ConferenceBasicInfo,
  ConferenceFileUpload,
  ConferenceFormActions,
} from "../../components/forms/ConferenceForm";

const EditConference: React.FC = () => {
  const navigate = useNavigate();

  // Get ID from URL path
  const getConferenceId = () => {
    const pathParts = window.location.pathname.split("/");
    return pathParts[pathParts.length - 1];
  };

  const id = getConferenceId();

  const [files, setFiles] = useState<File[]>([]);
  const [formData, setFormData] = useState({
    vietnameseName: "",
    englishName: "",
    type: "",
    budget: "",
    budgetSource: "",
    executionTime: "",
    endTime: "",
    venue: "",
    vietnameseParticipants: "",
    foreignParticipants: "",
    hostUnit: "",
    conferenceChair: "",
    participants: "",
    speakers: "",
    mainContent: "",
    evaluation: "",
  });

  // Mock data for editing - in real app, this would come from API
  const mockConferenceData = {
    vietnameseName: "dddddd >>",
    englishName: "International Conference on Technology",
    type: "Hội nghị quốc tế",
    budget: "0",
    budgetSource: "Ngân sách nhà nước",
    executionTime: "2025-08-29",
    endTime: "2025-08-29",
    venue: "Hà Nội, Việt Nam",
    vietnameseParticipants: "50",
    foreignParticipants: "30",
    hostUnit: "Viện Khoa học và Công nghệ",
    conferenceChair: "GS. Nguyễn Văn A",
    participants: "80",
    speakers: "10",
    mainContent: "Thảo luận về công nghệ mới",
    evaluation: "Thành công tốt đẹp",
  };

  useEffect(() => {
    // Load conference data for editing
    if (id) {
      // In real app, fetch data from API based on id
      setFormData(mockConferenceData);
    }
  }, [id]);

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Updating conference data:", formData);
    console.log("Files:", files);
    // TODO: Implement update functionality
    // After successful update, navigate back to conference list
    navigate("/conferences-workshops");
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <PageShell title="Sửa Hội nghị, hội thảo">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Sửa Hội nghị, hội thảo
          </h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <ConferenceBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <ConferenceFileUpload files={files} onFilesChange={setFiles} />
          </div>
        </div>

        <ConferenceFormActions onSave={handleSave} onCancel={handleCancel} />
      </div>
    </PageShell>
  );
};

export default EditConference;
